module.exports = __webpack_public_path__ + "static/media/Landschaft.0be03199.webp";